import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-map-windrose-loader',
  templateUrl: './map-windrose-loader.component.html',
  styleUrls: ['./map-windrose-loader.component.scss']
})
export class MapWindroseLoaderComponent implements OnInit {

  @Input() lat;
  @Input() lng;
  @Input() geoJsonObject;
  @Input() markers;
  constructor() {
  }

  ngOnInit() { }

  styleFunc(feature) {
    return ({
      clickable: false,
      fillColor: '#50a3ea', // feature.getProperty('color'),
      strokeWeight: 1,
      stroke: '#50a3ea'
    });
  }
  markerClicked(event, m) {
    m.isClicked = !m.isClicked;
  }

}
